import React from 'react';
import {Trans} from 'react-i18next';
import skinDetectionCategories from '../../../../../utils/config/skinDetectionCategories';

export const detectionMap = {
  skin_health: {
    value: 'skin_health',
    label: <Trans i18nKey="p.s.c.s.preview.skin.health">Skin Health</Trans>,
    score: 86,
    color: '#F23B77',
    labelI18n: {
      en: 'Skin Score',
      fr: 'Score de la peau',
      ja: '肌チェック',
      'zh-Hant': '肌膚分數',
      'zh-Hans': '肌肤分数',
      ko: '피부 점수',
      de: 'Haut-Score',
      es: 'Puntuación de la piel',
      it: 'Punteggio Pelle',
      pt: 'Pontuação de Pele',
      ar: 'درجة حالة البشرة',
    },
  },
  skin_age: {
    value: 'skin_age',
    label: <Trans i18nKey="p.s.c.s.preview.skin.age">Skin Age</Trans>,
    score: 86,
    color: '#F23B77',
  },
  age_spot: {
    value: 'age_spot',
    label: <Trans i18nKey="p.s.c.s.preview.spots">Spots</Trans>,
    score: 70,
    color: '#01c0fe',
    image: require('../../../../../assets/images/skincare/detection/spot.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/detectionlandscape/spot.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value === 'age_spot').labelI18n,
  },
  redness: {
    value: 'redness',
    label: <Trans i18nKey="p.s.c.s.preview.redness">Redness</Trans>,
    score: 78,
    color: '#ff2e00',
    image: require('../../../../../assets/images/skincare/detection/redness.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/detectionlandscape/redness.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value === 'redness').labelI18n,
  },
  moisture: {
    value: 'moisture',
    label: <Trans i18nKey="p.s.c.s.preview.moisture">Moisture</Trans>,
    score: 79,
    color: '#23d9e3',
    image: require('../../../../../assets/images/skincare/detection/moisture.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/detectionlandscape/moisture.svg'),
    imageStyle: {transform: 'translate(-50%, -50%) scale(0.5)'},
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value === 'moisture').labelI18n,
  },
  oiliness: {
    value: 'oiliness',
    label: <Trans i18nKey="p.s.c.s.preview.oiliness">Oiliness</Trans>,
    score: 80,
    color: '#ff8b0c',
    image: require('../../../../../assets/images/skincare/detection/oiliness.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/detectionlandscape/oiliness.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value === 'oiliness').labelI18n,
  },
  wrinkle: {
    value: 'wrinkle',
    label: (
      <Trans i18nKey="p.s.c.s.preview.addoreditconfig.wrinkles">Wrinkles</Trans>
    ),
    score: 85,
    color: '#6ADD54',
    image: require('../../../../../assets/images/skincare/detection/wrinkles.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/detectionlandscape/wrinkles.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value === 'wrinkle').labelI18n,
  },
  texture: {
    value: 'texture',
    label: <Trans i18nKey="p.s.c.s.preview.texture">Texture</Trans>,
    score: 92,
    color: '#cd86f2',
    image: require('../../../../../assets/images/skincare/detection/texture.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/detectionlandscape/texture.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value === 'texture').labelI18n,
  },
  eye_bag: {
    value: 'eye_bag',
    label: <Trans i18nKey="p.s.c.s.preview.eyebag">Eye Bag</Trans>,
    score: 86,
    color: '#cd5675',
    image: require('../../../../../assets/images/skincare/detection/eyebag.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/detectionlandscape/eyebag.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value === 'eye_bag').labelI18n,
  },
  dark_circle: {
    value: 'dark_circle',
    label: <Trans i18nKey="p.s.c.s.preview.dark.circles">Dark Circles</Trans>,
    score: 90,
    color: '#777B8B',
    image: require('../../../../../assets/images/skincare/detection/dark_circle.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/detection/dark_circle.svg'),
    imageStyle: {transform: 'translate(-50%, -50%) scale(0.5)'},
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value === 'dark_circle').labelI18n,
  },
  dark_circle_v2: {
    value: 'dark_circle_v2',
    label: <Trans i18nKey="p.s.c.s.preview.dark.circles">Dark Circles</Trans>,
    score: 90,
    color: '#777B8B',
    image: require('../../../../../assets/images/skincare/detection/dark_circle.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/detectionlandscape/dark_circle.svg'),
    imageStyle: {transform: 'translate(-50%, -50%) scale(0.5)'},
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value === 'dark_circle_v2').labelI18n,
  },
  firmness: {
    value: 'skinFirmness',
    label: <Trans i18nKey="p.s.c.s.preview.firmness">Firmness</Trans>,
    score: 88,
    color: '#fc85fe',
    image: require('../../../../../assets/images/skincare/detection/firmness.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/detectionlandscape/firmness.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value === 'firmness').labelI18n,
  },
  droopy_upper_eyelid: {
    value: 'droopyUpperEyelid',
    label: (
      <Trans i18nKey="p.s.c.s.preview.droopy.upper.eyelid">
        Droopy Upper Eyelid
      </Trans>
    ),
    score: 85,
    color: '#e545ff',
    image: require('../../../../../assets/images/skincare/detection/droopy_upper.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/detectionlandscape/droopy_upper.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value === 'droopy_upper_eyelid').labelI18n,
  },
  droopy_lower_eyelid: {
    value: 'droopyLowerEyelid',
    label: (
      <Trans i18nKey="p.s.c.s.preview.droopy.lower.eyelid">
        Droopy Lower Eyelid
      </Trans>
    ),
    score: 93,
    color: '#cb2e83',
    image: require('../../../../../assets/images/skincare/detection/droopy_lower.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/detectionlandscape/droopy_lower.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value === 'droopy_lower_eyelid').labelI18n,
  },
  radiance: {
    value: 'radiance',
    label: <Trans i18nKey="p.s.c.s.preview.radiance">Radiance</Trans>,
    score: 89,
    color: '#aabbcd',
    image: require('../../../../../assets/images/skincare/detection/radiance.png'),
    landscapeImage: require('../../../../../assets/images/skincare/detectionlandscape/radiance.png'),
    imageStyle: {transform: 'translate(-50%, -50%) scale(0.5)'},
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value === 'radiance').labelI18n,
  },
  pore: {
    value: 'pore',
    label: <Trans i18nKey="p.s.c.s.preview.pore">Pore</Trans>,
    score: 89,
    color: '#5DCFA6',
    image: require('../../../../../assets/images/skincare/detection/pores.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/detectionlandscape/pores.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value === 'pore').labelI18n,
  },
  acne: {
    value: 'acne',
    label: <Trans i18nKey="p.s.c.s.preview.acne">Acne</Trans>,
    score: 89,
    color: '#43A5DC',
    image: require('../../../../../assets/images/skincare/detection/acne.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/detectionlandscape/acne.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value === 'acne').labelI18n,
  },
};

export const detectionHdMap = {
  skin_health: {
    value: 'skin_health',
    label: <Trans i18nKey="p.s.c.s.preview.skin.health">Skin Health</Trans>,
    score: 86,
    color: '#F23B77',
    labelI18n: {
      en: 'Skin Score',
      fr: 'Score de la peau',
      ja: '肌チェック',
      'zh-Hant': '肌膚分數',
      'zh-Hans': '肌肤分数',
      ko: '피부 점수',
      de: 'Haut-Score',
      es: 'Puntuación de la piel',
      it: 'Punteggio Pelle',
      pt: 'Pontuação de Pele',
      ar: 'درجة حالة البشرة',
    },
  },
  skin_age: {
    value: 'skin_age',
    label: <Trans i18nKey="p.s.c.s.preview.skin.age">Skin Age</Trans>,
    score: 86,
    color: '#F23B77',
  },
  hd_acne: {
    value: 'hd_acne',
    label: <Trans i18nKey="p.s.c.s.preview.acne">Acne</Trans>,
    score: 89,
    color: '#43A5DC',
    image: require('../../../../../assets/images/skincare/hddetection/acne.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/acne.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value_v2_hd === 'hd_acne').labelI18n,
  },
  hd_dark_circle: {
    value: 'hd_dark_circle',
    label: <Trans i18nKey="p.s.c.s.preview.dark.circles">Dark Circles</Trans>,
    score: 90,
    color: '#777B8B',
    image: require('../../../../../assets/images/skincare/hddetection/dark_circle.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/dark_circle.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value_v2_hd === 'hd_dark_circle').labelI18n,
  },
  hd_droopy_lower_eyelid: {
    value: 'hd_droopy_lower_eyelid',
    label: (
      <Trans i18nKey="p.s.c.s.preview.droopy.lower.eyelid">
        Droopy Lower Eyelid
      </Trans>
    ),
    score: 93,
    color: '#cb2e83',
    image: require('../../../../../assets/images/skincare/hddetection/droopy_lower.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/droopy_lower.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value_v2_hd === 'hd_droopy_lower_eyelid').labelI18n,
  },
  hd_droopy_upper_eyelid: {
    value: 'hd_droopy_upper_eyelid',
    label: (
      <Trans i18nKey="p.s.c.s.preview.droopy.upper.eyelid">
        Droopy Upper Eyelid
      </Trans>
    ),
    score: 85,
    color: '#e545ff',
    image: require('../../../../../assets/images/skincare/hddetection/droopy_upper.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/droopy_upper.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value_v2_hd === 'hd_droopy_upper_eyelid').labelI18n,
  },
  hd_eye_bag: {
    value: 'hd_eye_bag',
    label: <Trans i18nKey="p.s.c.s.preview.eyebag">Eye Bag</Trans>,
    score: 86,
    color: '#cd5675',
    image: require('../../../../../assets/images/skincare/hddetection/eyebag.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/eyebag.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value_v2_hd === 'hd_eye_bag').labelI18n,
  },
  hd_firmness: {
    value: 'hd_firmness',
    label: <Trans i18nKey="p.s.c.s.preview.firmness">Firmness</Trans>,
    score: 88,
    color: '#fc85fe',
    image: require('../../../../../assets/images/skincare/hddetection/firmness.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/firmness.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value_v2_hd === 'hd_firmness').labelI18n,
  },
  hd_moisture: {
    value: 'hd_moisture',
    label: <Trans i18nKey="p.s.c.s.preview.moisture">Moisture</Trans>,
    score: 79,
    color: '#23d9e3',
    image: require('../../../../../assets/images/skincare/hddetection/moisture.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/moisture.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value_v2_hd === 'hd_moisture').labelI18n,
  },
  hd_oiliness: {
    value: 'hd_oiliness',
    label: <Trans i18nKey="p.s.c.s.preview.oiliness">Oiliness</Trans>,
    score: 80,
    color: '#ff8b0c',
    image: require('../../../../../assets/images/skincare/hddetection/oiliness.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/oiliness.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value_v2_hd === 'hd_oiliness').labelI18n,
  },
  hd_pore: {
    value: 'hd_pore',
    label: (
      <Trans i18nKey="u.c.skin.detection.categories.i.skincare.pore.full.face">
        Pores - Full Face
      </Trans>
    ),
    score: 89,
    color: '#5DCFA6',
    image: require('../../../../../assets/images/skincare/hddetection/pores_fullface.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/pores_fullface.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value_v2_hd === 'hd_pore').labelI18n,
  },
  hd_pore_forehead: {
    value: 'hd_pore_forehead',
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.pore.forehead">
        Pores - Forehead
      </Trans>
    ),
    score: 89,
    color: '#5DCFA6',
    image: require('../../../../../assets/images/skincare/hddetection/pores_forehead.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/pores_forehead.svg'),
    labelI18n: skinDetectionCategories.getSkinDetectionSubOptionLabel(
      'hd_pore',
      'hd_pore_forehead'
    ),
  },
  hd_pore_nose: {
    value: 'hd_pore_nose',
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.nose">
        Pores - Nose
      </Trans>
    ),
    score: 89,
    color: '#5DCFA6',
    image: require('../../../../../assets/images/skincare/hddetection/pores_nose.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/pores_nose.svg'),
    labelI18n: skinDetectionCategories.getSkinDetectionSubOptionLabel(
      'hd_pore',
      'hd_pore_nose'
    ),
  },
  hd_pore_cheek: {
    value: 'hd_pore_cheek',
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.cheek">
        Pores - Cheeks
      </Trans>
    ),
    score: 89,
    color: '#5DCFA6',
    image: require('../../../../../assets/images/skincare/hddetection/pores_cheek.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/pores_cheek.svg'),
    labelI18n: skinDetectionCategories.getSkinDetectionSubOptionLabel(
      'hd_pore',
      'hd_pore_cheek'
    ),
  },
  hd_radiance: {
    value: 'hd_radiance',
    label: <Trans i18nKey="p.s.c.s.preview.radiance">Radiance</Trans>,
    score: 89,
    color: '#aabbcd',
    image: require('../../../../../assets/images/skincare/hddetection/radiance.png'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/radiance.png'),
    imageStyle: {transform: 'translate(-50%, -50%) scale(0.5)'},
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value_v2_hd === 'hd_radiance').labelI18n,
  },
  hd_redness: {
    value: 'hd_redness',
    label: <Trans i18nKey="p.s.c.s.preview.redness">Redness</Trans>,
    score: 78,
    color: '#ff2e00',
    image: require('../../../../../assets/images/skincare/hddetection/redness.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/redness.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value_v2_hd === 'hd_redness').labelI18n,
  },
  hd_spot: {
    value: 'hd_spot',
    label: <Trans i18nKey="p.s.c.s.preview.spots">Spots</Trans>,
    score: 70,
    color: '#01c0fe',
    image: require('../../../../../assets/images/skincare/hddetection/spot.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/spot.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value_v2_hd === 'hd_spot').labelI18n,
  },
  hd_texture: {
    value: 'hd_texture',
    label: <Trans i18nKey="p.s.c.s.preview.texture">Texture</Trans>,
    score: 92,
    color: '#cd86f2',
    image: require('../../../../../assets/images/skincare/hddetection/texture.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/texture.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value_v2_hd === 'hd_texture').labelI18n,
  },
  hd_wrinkle: {
    value: 'hd_wrinkle',
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.full.face">
        Wrinkles - Full Face
      </Trans>
    ),
    score: 85,
    color: '#6ADD54',
    image: require('../../../../../assets/images/skincare/hddetection/wrinkles_fullface.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/wrinkles_fullface.svg'),
    labelI18n: skinDetectionCategories.getSkinDetectionSubOptionLabel(
      'hd_wrinkle',
      'hd_wrinkle'
    ),
  },
  hd_wrinkle_crowfeet: {
    value: 'hd_wrinkle_crowfeet',
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.crow.feet">
        Wrinkles - Crow's Feet
      </Trans>
    ),
    score: 85,
    color: '#6ADD54',
    image: require('../../../../../assets/images/skincare/hddetection/wrinkles_crowsfeet.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/wrinkles_crowsfeet.svg'),
    labelI18n: skinDetectionCategories.getSkinDetectionSubOptionLabel(
      'hd_wrinkle',
      'hd_wrinkle_crowfeet'
    ),
  },
  hd_wrinkle_nasolabial: {
    value: 'hd_wrinkle_nasolabial',
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.nasolabial">
        Wrinkles - Nasolabial Folds
      </Trans>
    ),
    score: 85,
    color: '#6ADD54',
    image: require('../../../../../assets/images/skincare/hddetection/wrinkles_nasolabial.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/wrinkles_nasolabial.svg'),
    labelI18n: skinDetectionCategories.getSkinDetectionSubOptionLabel(
      'hd_wrinkle',
      'hd_wrinkle_nasolabial'
    ),
  },
  hd_wrinkle_periocular: {
    value: 'hd_wrinkle_periocular',
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.periocular">
        Wrinkles - Periocular Lines
      </Trans>
    ),
    score: 85,
    color: '#6ADD54',
    image: require('../../../../../assets/images/skincare/hddetection/wrinkles_periocular.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/wrinkles_periocular.svg'),
    labelI18n: skinDetectionCategories.getSkinDetectionSubOptionLabel(
      'hd_wrinkle',
      'hd_wrinkle_periocular'
    ),
  },
  hd_wrinkle_glabellar: {
    value: 'hd_wrinkle_glabellar',
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.glabellar">
        Wrinkles - Glabellar Lines
      </Trans>
    ),
    score: 85,
    color: '#6ADD54',
    image: require('../../../../../assets/images/skincare/hddetection/wrinkles_glabellar.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/wrinkles_glabellar.svg'),
    labelI18n: skinDetectionCategories.getSkinDetectionSubOptionLabel(
      'hd_wrinkle',
      'hd_wrinkle_glabellar'
    ),
  },
  hd_wrinkle_forehead: {
    value: 'hd_wrinkle_forehead',
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.forehead">
        Wrinkles - Forehead Lines
      </Trans>
    ),
    score: 85,
    color: '#6ADD54',
    image: require('../../../../../assets/images/skincare/hddetection/wrinkles_forehead.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/wrinkles_forehead.svg'),
    labelI18n: skinDetectionCategories.getSkinDetectionSubOptionLabel(
      'hd_wrinkle',
      'hd_wrinkle_forehead'
    ),
  },
  hd_wrinkle_marionette: {
    value: 'hd_wrinkle_marionette',
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.wrinkles.marionette">
        Wrinkles - Marionette Lines
      </Trans>
    ),
    score: 85,
    color: '#6ADD54',
    image: require('../../../../../assets/images/skincare/hddetection/wrinkles_marionette.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/wrinkles_marionette.svg'),
    labelI18n: skinDetectionCategories.getSkinDetectionSubOptionLabel(
      'hd_wrinkle',
      'hd_wrinkle_marionette'
    ),
  },
  hd_teartrough: {
    value: 'hd_teartrough',
    label: (
      <Trans i18nKey="u.c.skin.detection.categories.i.skincare.tear.trough">
        Tear Trough
      </Trans>
    ),
    score: 90,
    color: '#FFC700',
    image: require('../../../../../assets/images/skincare/hddetection/tear_through.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/tear_through.svg'),
    labelI18n: skinDetectionCategories
      .getSkinDetectionCategories()
      .find(i => i.value_v2_hd === 'hd_teartrough').labelI18n,
  },
};

export const skinTypeHdMap = {
  combination_non_sensitive: {
    value: 'combination_non_sensitive',
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.combination">
        Combination
      </Trans>
    ),
    color: 'rgba(183, 111, 93, 1)',
    icon: require('../../../../../assets/images/skincare/hddetectionicon/combination_non_sensitive.png'),
    image: require('../../../../../assets/images/skincare/hddetection/skintype_full.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/skintype_full.svg'),
    categoryI18n: skinDetectionCategories
      .getSkinDetectionFacialArea()
      .find(i => i.value_v2_hd === 'skin_type').labelI18n,
    labelI18n: skinDetectionCategories
      .getSkinDetectionSkinTypes()
      .find(i => i.value_v2_hd === 'combination_non_sensitive').labelI18n,
  },
  oily_non_sensitive: {
    value: 'oily_non_sensitive',
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.oily">
        Oily
      </Trans>
    ),
    color: 'rgba(183, 111, 93, 1)',
    icon: require('../../../../../assets/images/skincare/hddetectionicon/oily_non_sensitive.png'),
    image: require('../../../../../assets/images/skincare/hddetection/skintype_t.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/skintype_t.svg'),
    categoryI18n: skinDetectionCategories
      .getSkinDetectionFacialArea()
      .find(i => i.value_v2_hd === 't_skin_type').labelI18n,
    labelI18n: skinDetectionCategories
      .getSkinDetectionSkinTypes()
      .find(i => i.value_v2_hd === 'oily_non_sensitive').labelI18n,
  },
  dry_non_sensitive: {
    value: 'dry_non_sensitive',
    label: (
      <Trans i18nKey="p.s.uiconfiguration.skincaredetection.detection.description.content.dry">
        Dry
      </Trans>
    ),
    color: 'rgba(183, 111, 93, 1)',
    icon: require('../../../../../assets/images/skincare/hddetectionicon/dry_non_sensitive.png'),
    image: require('../../../../../assets/images/skincare/hddetection/skintype_u.svg'),
    landscapeImage: require('../../../../../assets/images/skincare/hddetectionlandscape/skintype_u.svg'),
    categoryI18n: skinDetectionCategories
      .getSkinDetectionFacialArea()
      .find(i => i.value_v2_hd === 'u_skin_type').labelI18n,
    labelI18n: skinDetectionCategories
      .getSkinDetectionSkinTypes()
      .find(i => i.value_v2_hd === 'dry_non_sensitive').labelI18n,
  },
};

export const products = [
  {
    type: 'texture',
    image: require('../../../../../assets/images/consultation/skincare-prod1.jpg'),
    name: 'Advanced Night Intense Reset...',
  },
  {
    type: 'redness',
    image: require('../../../../../assets/images/consultation/skincare-prod2.png'),
    name: 'Idealist Pore Minimizing...',
  },
  {
    type: 'age_spot',
    image: require('../../../../../assets/images/consultation/skincare-prod3.png'),
    name: 'Nutritious Super Radiant Energy...',
  },
  {
    type: 'oiliness',
    image: require('../../../../../assets/images/consultation/skincare-prod4.png'),
    name: 'Revitalizing Supreme Anti...',
  },
  {
    type: 'moisture',
    image: require('../../../../../assets/images/consultation/skincare-prod5.png'),
    name: 'Daywear Advanced Multi-Protection...',
  },
  {
    type: 'texture',
    image: require('../../../../../assets/images/consultation/skincare-prod1.jpg'),
    name: 'Weekly Routine...',
  },
  {
    type: 'oiliness',
    image: require('../../../../../assets/images/consultation/skincare-prod4.png'),
    name: 'Natural Water Pore-Refining Toner...',
  },
  {
    type: 'moisture',
    image: require('../../../../../assets/images/consultation/skincare-prod5.png'),
    name: 'Eye Serum...',
  },
];

export const treatment = [
  require('../../../../../assets/images/consultation/treatment1.png'),
  require('../../../../../assets/images/consultation/treatment2.png'),
  require('../../../../../assets/images/consultation/treatment1.png'),
  require('../../../../../assets/images/consultation/treatment2.png'),
];

export const routine = [
  require('../../../../../assets/images/consultation/morning.png'),
  require('../../../../../assets/images/consultation/product1.png'),
  require('../../../../../assets/images/consultation/product2.png'),
  require('../../../../../assets/images/consultation/evening.png'),
  require('../../../../../assets/images/consultation/personal.png'),
  require('../../../../../assets/images/consultation/morning.png'),
  require('../../../../../assets/images/consultation/product1.png'),
];
